module.exports = __webpack_public_path__ + "img/c1.6e3c7645.jpg";